import {
  copyrightRange,
  ExternalLink,
  IndieTabletopClubLogo,
  ReleaseInfo,
  type LinkUtmParams,
} from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { hrefs } from "../../hrefs.ts";
import planetSmasherGames from "./planetsmashergames.webp";
import { footer } from "./style.css.ts";

export function Footer() {
  const utm: LinkUtmParams = { content: "footer" };

  const fathomAnalytics = (
    <ExternalLink className={interactiveText} href={hrefs.fathom()}>
      Fathom Analytics
    </ExternalLink>
  );

  const psg = (
    <ExternalLink className={interactiveText} href={hrefs.psg()}>
      Planet Smasher Games
    </ExternalLink>
  );

  const itc = (
    <ExternalLink className={interactiveText} href={hrefs.itc(utm)}>
      Indie Tabletop Club
    </ExternalLink>
  );

  const terms = (
    <ExternalLink href={hrefs.terms(utm)} className={interactiveText}>
      Terms of Service
    </ExternalLink>
  );

  const privacy = (
    <ExternalLink href={hrefs.privacy(utm)} className={interactiveText}>
      Privacy Policy
    </ExternalLink>
  );

  const cookies = (
    <ExternalLink href={hrefs.cookies(utm)} className={interactiveText}>
      Cookie Policy
    </ExternalLink>
  );

  const copyright = copyrightRange(2025);

  return (
    <footer className={footer.container}>
      <div className={footer.logos}>
        <ExternalLink href={hrefs.psg()} className={footer.logoLink}>
          <img
            src={planetSmasherGames}
            alt="Planet Smasher Games"
            className={footer.psg}
          />
        </ExternalLink>

        <ExternalLink href={hrefs.itc(utm)} className={footer.logoLink}>
          <IndieTabletopClubLogo textColor="white" />
        </ExternalLink>
      </div>
      <p>
        This app uses no tracking, other than anonymous, GDPR-compliant{" "}
        {fathomAnalytics}. For more information, see our {terms}, {privacy}, and{" "}
        {cookies}.
      </p>

      <p>
        Space Gits {copyright} {psg}. All rights reserved.
      </p>

      <p>
        Space Gits App {copyright} {itc}. All rights reserved.
      </p>
      <p>
        <ReleaseInfo
          branch={BRANCH}
          shortcode={COMMIT_SHORTCODE}
          backgroundColor="hsl(0 0% 100% / 0.2)"
        />
      </p>
    </footer>
  );
}
